.iconBox {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-grow: 0;
    flex-shrink: 0;
    background-color: var(--mantine-color-ldGray-0);
}

.tooltipPointerEvents {
    pointer-events: auto;
}

.rotated {
    rotate: 90deg;
}
